export default __webpack_public_path__ + "static/media/ic_close_3.f8ce7620.svg";